export const fallbackLng = "th";
export const languages = [fallbackLng, 'en', 'zh'];
export const defaultNS = "translation";
export const cookieName = "i18next";
export const cookieDefaultLangName = "defaultLang";
export const cookieLangListName = "langList";
export const cookieIsChangeLang = "isChangeLang";
const i18nextFallbackLng = {
    zh: ["en", "th"],
    default: [fallbackLng],
};

export function getOptions(lng = fallbackLng, ns = defaultNS) {
    return {
        // debug: true,
        supportedLngs: languages,
        fallbackLng: i18nextFallbackLng,
        lng,
        fallbackNS: defaultNS,
        defaultNS,
        ns,
    };
}

export type Language = (typeof languages)[number];
export type LocaleAttribute = "TH" | "EN" | "ZH";
// export type LanguageOptions = {
//     supportedLngs: Language[];
//     defaultLanguage: Language;
//     langauge: Language;
//     fallbackNS: string;
//     defaultNS: string;
//     ns: string;
// };
